import Device from "./Device";

export default class DeviceGroup {
  GID: number;
  GNAME: string;
  ORIENTATION: string;
  devices: Device[];

  constructor(GID: number, GNAME: string, ORIENTATION: string, devices: Device[]) {
    this.GID = GID;
    this.GNAME = GNAME;
	this.ORIENTATION = ORIENTATION;
    this.devices = devices;
  }

  static fromObject(obj: { GID: number; GNAME: string; ORIENTATION: string; devices?: any[] }) {
    let devices: Device[] = [];

    if (obj.devices) {
      obj.devices.forEach((dev) => {
        devices.push(Device.fromObject(dev));
      });
    }
    return new DeviceGroup(obj.GID, obj.GNAME, obj.ORIENTATION, devices);
  }

  toObject() {
    let devices: any[] = [];

    this.devices.forEach((dev) => {
      devices.push(dev.toObject());
    });
    return {
      GID: this.GID,
      GNAME: this.GNAME,
	  ORIENTATION: this.ORIENTATION,
      devices: devices,
    };
  }
}
